import { combineReducers } from 'redux';
import accountsReducer from './accountsReducer';
import authReducer from './authReducer';
import serversReducer from './serversReducer';
import ipsReducer from './ipsReducer';
import customNamesReducer from './customNamesReducer';
import taskReducer from './taskReducer';

export default combineReducers({ tasks: taskReducer, summonerNames: customNamesReducer, accounts: accountsReducer, auth: authReducer, servers: serversReducer, ips: ipsReducer });
